/* eslint-disable prettier/prettier */
import {
	createBrowserRouter,
	RouterProvider,
	Navigate,
} from 'react-router-dom';
import MainLayout from './components/layouts/MainLayout';
import { HeaderProvider } from './context/HeaderContext';
import PrivateRoute from './components/common/PrivateRoute';

// Pages
import AdminDashboard from './pages/admin/AdminDashboard';
import LearnerDashboard from './pages/learner/LearnerDashboard';
import PlaceholderPage from './pages/PlaceHolderPage';
import MasterCoachDashboard from './pages/master-coach-mentor/MasterCoachMentorDashboard';
import CoachMentorDashboard from './pages/coach-mentor/CoachMentorDashboard';
import NavAdminDashboard from './pages/admin/NavAdminDashboard';
import NavMasterCoachDashboard from './pages/master-coach-mentor/NavMasterCoachDashboard';
import NavCoachMentorDashboard from './pages/coach-mentor/NavCoachMentorDashboard';
import NavLearnerDashboard from './pages/learner/NavLearnerDashboard';
import ProfilePage from './pages/ProfilePage';
import SchedulePage from './pages/SchedulePage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import AuthCallback from './pages/AuthCallback';
import LoginError from './pages/LoginError';
import AdminApprovalPage from './pages/AdminTempFunctionPage';
import GuestDashboardPage from './pages/GuestDashboardPage';
import RoleBasedRedirect from './context/RoleBasedRedirect';
import ProgramsPage from './pages/ProgramsPage';
import ProgramDetailsPage from './pages/ProgramDetailsPage';
import ManageUsersPage from './pages/ManageUsersPage';
import SchedulerPage from './pages/schedule/SchedulePage';
import RoleProtectedRoute from './pages/RoleProtectedRoute';
import ManageUsersRedirect from './context/ManageUsersRedirect';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import AdminProgramsPage from './pages/admin/AdminProgramsPage';
import AdminEditProgramPage from './pages/admin/AdminEditProgramPage';
import ProgramsSmartRouter from './components/pageComponents/program/ProgramsSmartRouter';
import AcceptInvitationPage from './pages/AcceptInvitationPage';

const router = createBrowserRouter([
	// Public routes
	{ path: '/scheduler', element: <SchedulerPage /> },
	{ path: '/login', element: <LoginPage /> },
	{ path: '/login/error', element: <LoginError /> },
	{ path: '/signup', element: <SignupPage /> },
	{ path: '/auth/callback', element: <AuthCallback /> },
	{ path: '/forgotpassword', element: <ForgotPasswordPage /> },
	{ path: '/resetpassword', element: <ResetPasswordPage /> },
	{ path: '/accept-invitation', element: <AcceptInvitationPage /> },
	
	// Root redirect based on auth status
	{
		path: '/',
		element: <Navigate to="/login" replace />,
	},
	{
		path: '/temp-admin-approval',
		element: <AdminApprovalPage />,
	},
	// Protected routes - wrapped in PrivateRoute
	{
		path: '/',
		element: (
			<PrivateRoute>
				<MainLayout />
			</PrivateRoute>
		),
		children: [
			// --- Admin Section ---

			// { index: true, element: <RoleBasedRedirect /> },
			{ index: true, element: <Navigate to="dashboard" replace /> },

			{
				path: 'dashboard',
				element: <RoleBasedRedirect />,
			},

			{
				path: 'dashboard/manageUsers',
				element: (
					<RoleProtectedRoute allowedRoles={['coach', 'superadmin']}>
						<ManageUsersRedirect />
					</RoleProtectedRoute>
				),
			},

			// {
			//   path: "dashboard/programs",
			//   element: (
			//     <RoleProtectedRoute allowedRoles={["coachee"]}>
			//       <ProgramsPage />
			//     </RoleProtectedRoute>
			//   )
			// },

			// {
			//   path: "dashboard/programs",
			//   element: (
			//     <RoleProtectedRoute allowedRoles={["coach", "superadmin"]}>
			//       <AdminProgramsPage />
			//     </RoleProtectedRoute>
			//   )
			// },

			// {
			//   path: "dashboard/programs/:id",
			//   element: (
			//     <RoleProtectedRoute allowedRoles={["coach", "superadmin"]}>
			//       <AdminEditProgramPage />
			//     </RoleProtectedRoute>
			//   )
			// },

			{
				path: 'dashboard/profile',
				element: (
					<RoleProtectedRoute
						allowedRoles={['coach', 'coachee', 'superadmin']}
					>
						<ProfilePage />
					</RoleProtectedRoute>
				),
			},

			{
				path: 'dashboard/programs',
				element: (
					<RoleProtectedRoute
						allowedRoles={['coach', 'superadmin', 'coachee']}
					>
						<ProgramsSmartRouter />
					</RoleProtectedRoute>
				),
			},
			{
				path: 'dashboard/programs/:id',
				element: (
					<RoleProtectedRoute
						allowedRoles={['coach', 'superadmin', 'coachee']}
					>
						<ProgramsSmartRouter />
					</RoleProtectedRoute>
				),
			},

			{
				path: 'dashboard/profile',
				element: <ProfilePage />,
			},
		],
	},
]);

function App() {
	return (
		<HeaderProvider>
			<RouterProvider router={router} />
		</HeaderProvider>
	);
}

export default App;
